import { useLazyQuery, useQuery } from "@apollo/client";
import { CODART } from "../codarts.queries";
import {
  CodartQuery,
  CodartQueryVariables,
} from "../../../__generated__/CodartQuery";

export const useCodart = (code: string) => {
  return useQuery<CodartQuery, CodartQueryVariables>(CODART, {
    variables: { code },
  });
};

export const useLazyCodart = () => {
  return useLazyQuery<CodartQuery, CodartQueryVariables>(CODART);
};
